import PaginationObject from '@/docs-partials/api/schema/pagination-object.mdx';
import * as React from 'react';
export default {
  PaginationObject,
  React
};